export var dataHooks = {
  prefixIcon: 'button-prefix-icon',
  suffixIcon: 'button-suffix-icon'
};